<script>
import { filterObjectId } from "@/utils/helper"
import pick from "lodash/pick"

export default {
  name: "FormMixin",
  computed: {
    required_rule() {
      return [(v) => !!v || this.$t("errors.field_required")]
    },

    emailRules() {
      return [
        (v) => !!v || this.$t("errors.email_required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("errors.email_invalid"),
      ]
    },
  },
  data: function () {
    return {
      edition_mode: false,
      loading: false,
      user_id: null,
    }
  },
  mounted() {
    if (this.$route.params.user_id) {
      this.user_id = this.$route.params.user_id
    }
  },
  methods: {
    async submit(fields, redirect, filterField, success) {
      if (!this.$refs.form.validate()) {
        this.$toast.warning(this.$t("errors.fillMissingFields"))
        return
      }
      this.loading = true
      let func = this.ADD
      let edit = false
      if (this.formModel.id) {
        func = this.UPDATE
        edit = true
      }

      await func(
        pick(filterObjectId(this.formModel, filterField), fields)
      ).then(
        async (data) => {
          this.loading = false
          await this.$toast.success(
            this.$t("common.success_" + (edit ? "edit" : "add"))
          )
          if (redirect) {
            this.$router.push({ path: redirect(data) })
          }
          if (success) {
            success()
          }
        },
        () => {
          this.loading = false
        }
      )
    },
  },
}
</script>
